// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.DashboardDetailFooter.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { ACCESS_RIGHT } from 'logic/data/Izenda.AuthorizationConstants';
import LicenseCheckerConstants from 'logic/data/Izenda.LicenseCheckerConstants';
import React from 'react';
import { Link } from 'react-router';
import ActionButton from 'share/components/controls/Izenda.ActionButton';
import Button from 'share/components/controls/Izenda.Button';
import ExportButton from 'share/components/controls/Izenda.ExportButton';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import AuthorizationValidator from 'share/components/hoc/Izenda.AuthorizationValidator';
import connect from 'share/enhancers/Izenda.Connect';
import PrintDashboardButton from '../Izenda.PrintDashboardButton';
import actions from './Izenda.DashboardDetailFooterActions';
import uiState from 'logic/Izenda.UiState';

const AuthorizationButton = AuthorizationValidator()(Button);
const AuthorizationPrintDashboardButton = AuthorizationValidator()(PrintDashboardButton);
const AuthorizationExportButton = AuthorizationValidator()(ExportButton);

const DashboardDetailFooter = ({
  copyDashboard,
  detailUri,
  localization,
  authorizationConstants,
  boardDetail,
  authorization,
  store,
  moveDashboard,
  openEmailPopup,
  subscribeDashboard,
  deleteDashboard
}) => {
  const permissionKeys = authorizationConstants.PERMISSION_KEY;

  const hasScheduleLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Scheduling);
  const hasExportLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Exporting);
  const { accessPriority, name, id: dashboardId } = boardDetail;

  return (
    <GridLayout>
      <GridLayout.Row>
        <GridLayout.Col cols='12' className='text-right'>
          <div className='u_inlineBlock izenda-ActionBar'>
            <ActionButton>
              <Link to={detailUri}>
                <Button className='pull-left' label={localization.getText('COMMON_LABEL_OPEN')} />
              </Link>
              {(accessPriority === ACCESS_RIGHT.FullAccess || accessPriority === ACCESS_RIGHT.SaveAs) &&
                boardDetail.copyable && (
                  <AuthorizationButton
                    label={localization.getText('COMMON_LABEL_COPY')}
                    onClick={copyDashboard}
                    keys={[permissionKeys.DashboardsCanCreateNewDashboardValue]}
                  />
                )}
              {accessPriority === ACCESS_RIGHT.FullAccess && boardDetail.movable && (
                <AuthorizationButton
                  label={localization.getText('COMMON_LABEL_MOVE')}
                  onClick={moveDashboard}
                  keys={[permissionKeys.DashboardsActionsOverwriteExistingDashboard]}
                />
              )}
              {hasExportLicense && !uiState.isMobile && (
                <AuthorizationPrintDashboardButton
                  store={store}
                  export={store.printDashboard}
                  id={dashboardId}
                  name={name}
                  keys={[permissionKeys.DashboardsActionsPrint]}
                />
              )}
              {hasExportLicense && !uiState.isMobile && (
                <AuthorizationExportButton
                  store={store}
                  export={store.exportDashboard}
                  id={dashboardId}
                  isDashboard
                  name={name}
                  keys={[permissionKeys.DashboardsActionsExporting]}
                />
              )}
              <AuthorizationButton
                onClick={openEmailPopup}
                label={localization.getText('COMMON_LABEL_EMAIL')}
                keys={[permissionKeys.DashboardsActionsEmail]}
              />
              {hasScheduleLicense && (
                <AuthorizationButton
                  label={localization.getText('COMMON_LABEL_SUBSCRIBE')}
                  onClick={subscribeDashboard}
                  keys={[permissionKeys.DashboardsActionsSubscribe]}
                />
              )}
              {accessPriority === ACCESS_RIGHT.FullAccess && boardDetail.deletable && (
                <AuthorizationButton
                  label={localization.getText('COMMON_LABEL_DELETE')}
                  onClick={deleteDashboard}
                  keepDisplay
                  keys={[permissionKeys.DashboardsActionsDel]}
                />
              )}
            </ActionButton>
          </div>
        </GridLayout.Col>
      </GridLayout.Row>
    </GridLayout>
  );
};

export default connect(actions)(DashboardDetailFooter);



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardList/Izenda.DashboardDetailFooter.js